"use client";

import { useEffect, useState } from "react";

/* Module-scoped, so it resets on every full document load and survives
   route remounts within one visit. */
let navigated = false;

/**
 * Remounts on every route change: the incoming page focuses in with the
 * house blur-fade (Reveal's doctrine at page scale — no translate) while
 * the persistent chrome in layout.tsx holds still. The fade is a veil
 * overlay (.oi-route-veil in custom.css) rather than an animation on the
 * content, so the page paints — and LCP records — at first paint; the
 * global reduced-motion collapse still applies. The initial document load
 * skips the veil entirely: there is no outgoing page to fade from, and an
 * opaque cover over a fresh paint is pure Speed Index cost.
 */
export default function Template({ children }: { children: React.ReactNode }) {
  const [veiled] = useState(() => navigated);
  useEffect(() => {
    navigated = true;
  }, []);
  return (
    <div className="oi-route-enter">
      {children}
      {veiled && <div className="oi-route-veil" aria-hidden />}
    </div>
  );
}
